/**
 * [INPUT]: 依赖 @radix-ui/react-collapsible 的受控/非受控展开状态与可访问触发器
 * [OUTPUT]: 对外提供 Collapsible、CollapsibleTrigger、CollapsibleContent
 * [POS]: zinnercms-design-system/ui 的无视觉状态 primitive，由 Sidebar 等上层组合决定具体几何与反馈
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible"

function Collapsible({
  ...props
}) {
  return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />;
}

function CollapsibleTrigger({
  ...props
}) {
  return (<CollapsiblePrimitive.CollapsibleTrigger data-slot="collapsible-trigger" {...props} />);
}

function CollapsibleContent({
  ...props
}) {
  return (<CollapsiblePrimitive.CollapsibleContent data-slot="collapsible-content" {...props} />);
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
